<template>
  <div id="projetsetup">
    <div class="right">
      <div class="right_header">绘图仪配置文件</div>
      <div class="right_table">
        <el-table v-loading="loading" :data="tableData" border element-loading-text="拼命加载中"
          highlight-current-row height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size:16px;color:#000;margin-top:36px">暂无数据</p>
          </template>
          <el-table-column label="文件名称" prop="fileName">
            <template slot-scope="{ row }">
              <div style="display:flex;align-items: center">
                <img :src="icon" style="margin-right:8px" alt="" />
                <span>{{ row.fileName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="createTime" min-width="120px" />
          <el-table-column label="文件大小" prop="fileSizeStr" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import print from "@/CommonDP/service/plotterConfig-service.js";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      icon: require("@/CommonDP/assets/standard/img.png"),
      zanwu: require("@/CommonDP/assets/暂无数据.png")
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  watch: {},
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await print.queryPlotterConfigList(this.enterpriseId);
      if (res.result === "0") {
        this.tableData = res.data;
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$left-width: 226px;
$header-height: 46px;
#projetsetup {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  .right {
    height: 100%;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
    .right_header {
      height: $header-height;
      border-bottom: 1px solid #ebefff;
      font-size: 16px;
      font-weight: 600;
      line-height: $header-height;
      color: var(--key-color);
    }
    .right_table {
      position: absolute;
      top: $header-height + 20px;
      left: 0;
      right: 0;
      bottom: 40px;
      padding: 4px 10px;
    }
  }
}
</style>
